jQuery(document).ready(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }



    $('#fixed-bar-cart select').change(function() {
      var value = this.value;
      var optionName = $(this).find(':selected').attr('name');
      var valueSelected = $(this).find(':selected').val();
      console.log('optionName---'+optionName+'---valueSelected = '+valueSelected);
      jQuery('.variant-wrapper.js fieldset[name="'+optionName+'"] input[value="'+valueSelected+'"]').click();
       updateFixedBar();
    });

    jQuery('.variant-input-wrap .variant-input :radio').change(function() {
       var ValSelected = $(this).val();
       var OpName = $(this).attr('name');
       $('#fixed-bar-cart select[name="'+OpName+'"]').val(ValSelected).change();
      
    });

  

    $("#fixed-bar-cart #fixed-bar-add").click(function(){
      $('.product-single__meta button.add-to-cart').trigger('click');
    });


  
});

var updateFixedBar = function() {
  var productPrice = jQuery('.product-single__meta .product-block--price').html();
  var buttonText = jQuery('.product-single__meta button.add-to-cart').html();
  jQuery('#fixed-bar-cart #fixed-bar-price').html(productPrice);
  jQuery('#fixed-bar-cart #fixed-bar-add').html(buttonText);
}


jQuery(window).load(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }


   updateFixedBar();



  
});

  jQuery(document).on("click", '.cart__remove a', function(e) {
    e.preventDefault();
    jQuery(this).closest('.cart__item-sub').find('.js-qty__num').val('0');

    var variant_id = jQuery(this).attr('data-id');
     console.log(variant_id);
    var obj = {};
    obj[variant_id]= 0;
    removem_data = { updates: obj };
    jQuery.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: JSON.stringify(removem_data), 
        contentType: "application/json",
        dataType: 'json',
        success: function(responce) {
          // console.log('removed');
		  //$('.cart__item[data-id="'+variant_id+'"]').remove();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:build'));

        }            
      });
  }); 


$(window).scroll(function() {

    if ($(this).scrollTop() < $('#product_block_buyBtn').offset().top) {
    	$('#fixed-bar-cart').removeClass('active');
	}

	if ($(this).scrollTop() >= $('#product_block_buyBtn').offset().top) {
    	$('#fixed-bar-cart').addClass('active');
	}
	

});


